<template>
  <div style="font-family: poppinsregular">
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-snackbar
      v-model="showSnackBar"
      color="black"
      rounded
      centered
      timeout="2000"
    >
      <v-layout wrap justify-center>
        <v-flex text-center class="align-self-center">
          <span style="color: #ffffff">
            {{ msg }}
          </span>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex xs12>
        <v-layout wrap>
          <v-flex xs6 text-left>
            <span style="color: #000; font-size: 20px; font-family: poppinsbold"
              >News List</span
            >
          </v-flex>
          <v-flex xs6 text-right>
            <v-btn
              small
              style="text-transform: none"
              color="#4da6ff"
              @click="dialog = true"
            >
              Add news
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout v-for="(item, i) in CodeList" :key="i" pt-1>
      <v-flex>
        <v-card>
          <v-layout wrap pa-3>
            <v-flex xs6 lg12 px-5>
              <v-layout wrap>
                <v-flex xs12 text-left pb-3>
                  <!-- <v-card
                    elevation="1"
                    class="py-2 px-4"
                    style="border-radius: 20px"
                    color="#e6e6e6"
                  >
                    <b> {{ item.hsnCode }} </b>
                  </v-card> -->
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    hide-details
                    height="100px"
                    background-color="#d9f2d9"
                    solo
                    v-model="item.description"
                    style="border-radius: 20px !important"
                  >
                  </v-textarea>
                </v-flex>
                
              </v-layout>
            </v-flex>

            <v-flex xs12 text-right pt-4>
              <v-btn
                small
                rounded
                color="#ff8080"
                @click="(deleteDialog = true), (DeleteId = item._id)"
              >
                <v-icon small color="white">mdi-delete</v-icon>
              </v-btn>
              <v-btn
                class="ml-3"
                small
                rounded
                color="#53c653"
                @click="(dialogedit = true), (editItem = item)"
              >
                <v-icon small color="white">mdi-pencil</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout wrap pt-3>
      <!-- <v-flex xs12>
        <v-pagination
          :length="pages"
          :total-visible="8"
          v-model="currentPage"
          color="#FDAC53"
        ></v-pagination>
      </v-flex> -->
    </v-layout>
    <v-dialog width="600px" v-model="dialog">
      <v-card width="600px" style="font-family: poppinsregular">
        <v-layout wrap pa-5>
          <v-flex xs12>
            <span> <b> Add news </b></span>
          </v-flex>
         
          <v-flex xs12 pt-1>
            <v-textarea dense label="Name" v-model="curItem.name"> </v-textarea>
          </v-flex>
         
          <v-flex xs12 text-right>
            <v-btn
              small
              style="text-transform: none"
              @click="dialog = false"
              class="mr-3"
            >
              Cancel
            </v-btn>

            <v-btn small style="text-transform: none" @click="AddHsn()">
              Save
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-dialog width="600px" v-model="dialogedit">
      <v-card width="600px" style="font-family: poppinsregular">
        <v-layout wrap pa-5>
          <v-flex xs12 pb-3>
            <span> <b>Do You Want to Update News...? </b></span>
          </v-flex>

          <v-flex xs12 text-right>
            <v-btn
              small
              style="text-transform: none"
              @click="dialogedit = false"
              class="mr-3"
            >
              Cancel
            </v-btn>

            <v-btn
              small
              style="text-transform: none"
              @click="editHsn(editItem)"
            >
              Save
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-dialog width="600px" v-model="deleteDialog">
      <v-card width="600px" style="font-family: poppinsregular">
        <v-layout wrap pa-5>
          <v-flex xs12 pb-3>
            <span> <b>Do You Want to Delete this News...? </b></span>
          </v-flex>

          <v-flex xs12 text-right>
            <v-btn
              small
              style="text-transform: none"
              @click="deleteDialog = false"
              class="mr-3"
            >
              Cancel
            </v-btn>
            <v-btn
              small
              style="text-transform: none"
              @click="deleteHSNCode(DeleteId)"
            >
              ok
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      deleteDialog: false,
      DeleteId: null,
      editItem: {},
      showSnackBar: false,
      ServerError: false,
      appLoading: false,
      CodeList: [],
      pages: 0,
      currentPage: 1,
      dialog: false,
      dialogedit: false,
      curItem: {},
      msg: null,
    };
  },
  watch: {
    currentPage() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    deleteHSNCode(id) {
      axios({
        url: "/admin/delete/news",
        method: "post",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          id: id,
        },
      })
        .then((response) => {
          this.showSnackBar = true;
          this.dialog = false;
          this.msg = response.data.msg;
          this.DeleteId = 0;
          this.appLoading = false;
          this.getData();
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },

    AddHsn() {
      this.appLoading = true;
      axios({
        url: "/admin/news/add",
        method: "post",
        headers: {
          token: localStorage.getItem("token"),
        },
        data:{
        description: this.curItem.name,
        }

      })
        .then((response) => {
          this.showSnackBar = true;
          this.dialog = false;
          this.msg = response.data.msg;
          this.curItem = {};
          this.appLoading = false;
          this.getData();
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },

    getData() {
      this.appLoading = true;
      axios({
        url: "/admin/news/list",
        method: "GET",
        headers: {
          token: localStorage.getItem("token"),
        },
        params: {
          page: this.currentPage,
          limit: 50,
          searchKeyword: "",
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.CodeList = response.data.data;
          this.pages = Math.ceil(response.data.totalLength / 50);
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },

    editHsn(item) {
      axios({
        url: "/admin/news/edit",
        method: "post",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          id: item._id,
          description: item.description,
         
        },
      })
        .then((response) => {
          this.showSnackBar = true;
          //   this.dialog = false;
          this.msg = response.data.msg;
          this.dialogedit = false;
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
